<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      this_is_final: {},
      combinations: [],
      attributeData: [],
      attributeValues: [],
      uploadFile: true,
      isEdit: false,
      attribute_value: null,
      attribute_id: null,
      associatedvarients: null,
      id: null,
      selectedAttributeId: null,
      productAttributeData: [],
    };
  },
  mounted() {
    this.getAttributes();
  },
  methods: {
    async uploadImage(event) {
      const loader = this.$loading.show({ loader: "dots" });
      const FILE = event.target.files[0];
      const formData = new FormData();
      formData.append("csv_files", FILE, FILE.name);
      formData.append("product_id", this.id);
      try {
        await this.$store.getters.client.post("/variant/csv-variant/", formData);
        this.$emit("updatePage", 3);
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },
    async getvariant() {
      const loader = this.$loading.show({ loader: "dots" });
      try {
        const response = await this.$store.getters.client.post(`variant/get-variant/`, { product_id: this.id });
        this.this_is_final = response.data.data;
        const y = this.this_is_final.AttributeValueSorted.map((x) => {
          return {
            attribute_values: x.attribute_values,
            id: x,
            name: x.attribute_name,
          }
        });
        this.attributeData = this.attributeData.concat(y);
        this.productAttributeData = this.this_is_final.AttributeValueSorted.map(x => ({
          ...x,
          all_attribute_val: x.attribute_values,
          sequence: 0,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },

    addField() {
      this.productAttributeData.push({ attribute_value: [], id: null, all_attribute_val: [] });
    },
    addQuentityRow(item) {
      item.prices.push({ quantity: 1, express: 0, standard: 0, value: 0 });
    },
    removeQuentityRow(item, val) {
      val.prices.splice(item, 1);
    },
    selectedAttribute(att, index) {
      this.selectedAttributeId = att.id;
      this.getAttributes(index);
    },
    selectedAttributeValue(att, index) {
      this.productAttributeData[index].attribute_value.push(att.id);
    },
    deleteField(index) {
      this.productAttributeData.splice(index, 1);
    },
    async getAttributes(index) {
      const loader = this.$loading.show({ loader: "dots" });
      try {
        if (this.selectedAttributeId === null) {
          const response = await this.$store.getters.client.get(`/attributes/`);
          this.attributeData = response.data.results;
        } else {
          this.attribute_value = null;
          this.attributeValues = [];
          const response = await this.$store.getters.client.get(`/attributes/${this.selectedAttributeId}`);
          this.productAttributeData[index].all_attribute_val = response.data.attribute_values;
        }
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },
    async reFreshAttribute(index, item) {
      console.log("item", item);
      if (item.attribute_id) {
        const loader = this.$loading.show({ loader: "dots" });
        try {
          const response = await this.$store.getters.client.get(`/attributes/${item.attribute_id}`);
          this.productAttributeData[index].all_attribute_val = response.data.attribute_values;
        } catch (error) {
          console.error(error);
        } finally {
          loader.hide();
        }
      }
    },
    checkNumericInput(detail, field) {
      const value = parseFloat(detail[field]);
      detail[`isInvalid${field.charAt(0).toUpperCase() + field.slice(1)}`] = isNaN(value);
    },
    generateCombination() {
      this.associatedvarients = this.productAttributeData
      const result = [];
      const [first, ...rest] = this.productAttributeData.map(
        (obj) => obj.attribute_values
      );
      const product = rest.reduce(
        (acc, arr) => acc.flatMap((x) => arr.map((y) => [...x, y])),
        first.map((x) => [x])
      );
      for (let i = 0; i < product.length; i++) {
        const combination = [];
        for (let j = 0; j < this.productAttributeData.length; j++) {
          const obj = this.productAttributeData[j];
          const option = obj.attribute_id ? obj.attribute_id : obj.id.id;
          const value = product[i][j];
          combination.push({ option, value });
        }
        result.push({
          option_values: combination,
          prices: [{ quantity: 1, express: 0, standard: 0, value: 0 }],
        });
      }
      this.this_is_final.variants = result;
    },
    async submitVarient() {
      // this.generateCombination();
      const test = this.productAttributeData.map(element => {
        let element_id = null
        if (element.id) {
          element_id = element.id.id
        }
        if (element.attribute_id) {
          element_id = element.attribute_id
        }
        // const attributeId = element.attribute_id || (element.id && element.id.id);
        return {
          attribute_id: element_id,
          attribute_value_id: element.attribute_values.map(item => item.id),
        };
      })
      const data = {
        variants: this.this_is_final.variants.map(variant => ({
          prices: variant.prices,
          option_values: variant.option_values.map(optionValue => ({
            option_id: optionValue.option?.id ? optionValue.option.id : optionValue.option,
            value_id: optionValue.value.id,
          })),
        })),
        product_id: this.id,
        associated_attribute: test,
      };
      const loader = this.$loading.show({ loader: "dots" });
      try {
        await this.$store.getters.client.post(`variant/create-variant/`, data);
        // this.$emit("updatePage", 3);
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },
  },
  created() {
    if ("id" in this.$route.params) {
      this.isEdit = true;
      this.id = this.$route.params.id;
    }
  },
};
</script>

<template>
  <div class="row">
    <b-col cols="12">
      <div @click="uploadFile = !uploadFile">
        <b-button variant="warning" class="w-100 mb-3" v-if="uploadFile" @click="getvariant()">Upload Manually</b-button>
        <b-button variant="warning" class="w-100 mb-3" v-else>Upload file</b-button>
      </div>
    </b-col>
    <b-col cols="12" v-show="uploadFile">
      <b-card title="Upload Price List">
        <div class="border-img">
          <input type="file" @change="uploadImage($event)" />
        </div>
      </b-card>
    </b-col>
    <div class="col-lg-12" v-show="!uploadFile">
      <div class="card">
        <div class="card-body">
          <div class="add-button mx-0">
            <button @click="addField()" class="btn btn-primary btn-sm" type="button">+ Add Attribute</button>
          </div>
          <div class="form-group" v-if="productAttributeData.length > 0">
            <div class="row" v-for="(item, index) of productAttributeData" :key="index">
              <!-- {{ item }} -->
              <div class="col">
                <label>Attribute </label>
                <div class="d-flex">
                  <div class="form-control" v-if="item.attribute_name">{{ item.attribute_name }}</div>
                  <multiselect name="category_id" v-else v-model="item.id" :options="attributeData" label="name" track-by="id"
                    @select="selectedAttribute($event, index)"></multiselect>
                  <div class="text-success ml-2">
                    <i @click="reFreshAttribute(index, item)" class="mdi mdi-refresh-circle font-size-18"></i>
                  </div>
                </div>
              </div>
              <div class="col">
                <label>Attribute Value</label>
                <multiselect name="category_value" v-model="item.attribute_values" :options="item.all_attribute_val"
                  label="name" track-by="id" :multiple="true" @select="generateCombination()" :hide-selected="true"
                  :searchable="true"></multiselect>
              </div>
              <div class="col-2">
                <label>Delete</label>
                <div class="text-danger">
                  <i @click="deleteField(index); generateCombination();" class="mdi mdi-trash-can font-size-18"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-card title="Varients">
        <b-row class="mb-3">
          <div class="col-5">Combination</div>
          <div class="col">Quentity</div>
          <div class="col">Express</div>
          <div class="col">Standard</div>
          <div class="col">Value</div>
          <div class="col"></div>
        </b-row>
        <b-row class="mb-3" v-for="(combination, index) in this_is_final.variants" :key="index">
          <b-col cols="5">
            <b-badge class="mr-2" variant="light" v-for="(val, j) in combination.option_values" :key="j">{{
              val.value.name }}</b-badge>
          </b-col>
          <b-col cols="7">
            <b-row class="mb-2" v-for="(detail, i) in combination.prices" :key="i">
              <div class="col">
                <b-form-input v-model="detail.quantity" size="sm" type="number" class="small-input"
                  @input="checkNumericInput(detail, 'quantity')"
                  :class="{ 'invalid-input': detail.isInvalidQuantity }"></b-form-input>
              </div>
              <div class="col">
                <b-form-input v-model="detail.express" size="sm" type="number" class="small-input"
                  @input="checkNumericInput(detail, 'express')"
                  :class="{ 'invalid-input': detail.isInvalidExpress }"></b-form-input>
              </div>
              <div class="col">
                <b-form-input v-model="detail.standard" size="sm" type="number" class="small-input"
                  @input="checkNumericInput(detail, 'standard')"
                  :class="{ 'invalid-input': detail.isInvalidStandard }"></b-form-input>
              </div>
              <div class="col">
                <b-form-input v-model="detail.value" size="sm" type="number" class="small-input"
                  @input="checkNumericInput(detail, 'value')"
                  :class="{ 'invalid-input': detail.isInvalidValue }"></b-form-input>
              </div>
              <div class="col">
                <b-button variant="success" size="sm" v-if="i === combination.prices.length - 1"
                  @click="addQuentityRow(combination)">+</b-button>
                <b-button variant="danger" size="sm" v-else @click="removeQuentityRow(i, combination)">-</b-button>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="d-flex justify-content-between">
      <button @click="$emit('previousPage', 1)" type="button" class="btn btn-danger float-right">Back</button>
      <button @click="submitVarient()" type="button" class="btn btn-primary float-right">Next</button>
    </div>
  </div>
</template>

<style>
.invalid-input {
  border-color: red !important;
}

.small-input {
  -moz-appearance: textfield;
}

.small-input::-webkit-inner-spin-button {
  display: none;
}

.small-input::-webkit-outer-spin-button,
.small-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
